export default __webpack_public_path__ + "static/media/llm.d8e66964.webp";